import React, { useState } from 'react';
import { Box, Tabs, Tab, Stack } from '@mui/material';
import BulkEmailCompose from './bulk-email-compose.component';
import BulkEmailHistory from './bulk-email-history.component';
import Iconify from '../common/iconify.component';

const TABS_CONFIG = [
  {
    value: 'COMPOSE',
    label: 'Compose',
    icon: 'ic:outline-send',
    component: BulkEmailCompose,
  },
  {
    value: 'HISTORY',
    label: 'History',
    icon: 'ic:outline-history',
    component: BulkEmailHistory,
  },
];

const BulkEmail = () => {
  const [tabValue, setTabValue] = useState(TABS_CONFIG[0].value);

  return (
    <Box sx={{ p: 1 }}>
      <Stack direction="row" spacing={2} sx={{ mb: 2 }}>
        <Tabs
          value={tabValue}
          onChange={(_, val) => setTabValue(val)}
          textColor="primary"
          indicatorColor="primary"
          aria-label="tabs"
        >
          {TABS_CONFIG.map((tab, index) => (
            <Tab
              key={index + 1}
              icon={<Iconify icon={tab.icon} />}
              iconPosition="start"
              value={tab.value}
              label={tab.label}
            />
          ))}
        </Tabs>
      </Stack>

      {TABS_CONFIG.map(
        ({ value, component: Component }) =>
          tabValue === value && <Component key={value} />
      )}
    </Box>
  );
};

export default BulkEmail;
